import React from 'react'

import FormControlled from 'common/Forms/Base/FormControlled'
import PraFileAttachment from 'common/PraFileAttachment'

export default props => <FormControlled tag={PraFileAttachment} {...props} />
